import { supabase } from '../lib/supabase';

// Storage Service - Handle image uploads to Supabase Storage

export const storageService = {
    // Upload image to Supabase Storage
    async uploadImage(file, folder = 'blog-images') {
        try {
            // Generate unique filename
            const fileExt = file.name.split('.').pop();
            const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExt}`;
            const filePath = `${folder}/${fileName}`;

            // Upload to Supabase Storage
            const { error } = await supabase.storage
                .from('blog-images')
                .upload(filePath, file, {
                    cacheControl: '3600',
                    upsert: false
                });

            if (error) throw error;

            // Get public URL
            const { data: { publicUrl } } = supabase.storage
                .from('blog-images')
                .getPublicUrl(filePath);

            return {
                success: true,
                url: publicUrl,
                path: filePath
            };
        } catch (error) {
            console.error('Error uploading image:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Delete image from Supabase Storage
    async deleteImage(filePath) {
        try {
            const { error } = await supabase.storage
                .from('blog-images')
                .remove([filePath]);

            if (error) throw error;

            return {
                success: true,
                message: 'Image deleted successfully'
            };
        } catch (error) {
            console.error('Error deleting image:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Get public URL for an image
    getPublicUrl(filePath) {
        const { data } = supabase.storage
            .from('blog-images')
            .getPublicUrl(filePath);

        return data.publicUrl;
    },

    // Upload base64 image (convert to file first)
    async uploadBase64Image(base64String, fileName = 'image.jpg') {
        try {
            // Convert base64 to blob
            const response = await fetch(base64String);
            const blob = await response.blob();

            // Create file from blob
            const file = new File([blob], fileName, { type: blob.type });

            // Upload using regular upload method
            return await this.uploadImage(file);
        } catch (error) {
            console.error('Error uploading base64 image:', error);
            return {
                success: false,
                error: error.message
            };
        }
    }
};

